import { React, useState, useEffect, useCallback, useRef } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  CustomGetAPI,
  GetAPI,
  PostAPI,
  PutAPI,
  CustomPostAPI,
} from "../Utils/APIConnector";
import _ from "lodash";
import HelmetMetaTag from "../Utils/HelmetMetaTag/HelmetMetaTag";

export default function NewVenueSearch(props) {
  const userLocation = localStorage.getItem("userLocation");
  const [searchText, setSearchText] = useState("");
  const [availableLetters, setAvailableLetters] = useState([]);
  const [selectedLetter, setSelectedLetter] = useState("");
  const [hoveredAlphabet, setHoveredAlphabet] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [cityData, setCityData] = useState();
  const [sportData, setSportData] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [showSearchList, setShowsearchList] = useState(false);
  const [sport, setSport] = useState(false);
  const SearchRef = useRef(null);
  const navigate = useNavigate();

  const goToVenueList = (id, name) => {
    //setSport(true);
    setSelectedCity(name.toLocaleLowerCase());
    window.localStorage.setItem("userLocation", name?.toLocaleLowerCase());
    setShowsearchList(false);
    if (!props?.packagePage) {
      window.location.href = `/venue-search/${name.toLocaleLowerCase()}/${
        props.isevent === "true" ? "events" : "sports"
      }/${props.sport ? props.sport : "all"}`;
    } else {
      window.location.reload();
    }

    // navigate(
    //
    // );
  };

  const handleSavedVenues = () => {
    navigate("/saved-venues");
  };

  const handleSavedQueries = () => {
    navigate("/savedqueries");
  };

  const handleHorizontalScroll = (letter) => {
    setSelectedLetter(letter);
    const element = document.getElementById(letter);
    element?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  };

  useEffect(() => {
    function handleClickOutside(ref) {
      return function (event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowsearchList(false);
        }
      };
    }
    const handleFilterClick = handleClickOutside(SearchRef);

    document.addEventListener("mousedown", handleFilterClick);

    return () => {
      document.removeEventListener("mousedown", handleFilterClick);
    };
  }, [SearchRef]);

  useEffect(() => {
    CustomGetAPI("/venue/GetAllCity").then((result) => {
      result = JSON.parse(result);
      if (result?.status === "success") {
        setCityData(result?.cities);
      }
    });
    CustomGetAPI("/venue/GetAllSport").then((result) => {
      result = JSON.parse(result);
      if (result?.status === "success") {
        setSportData(result?.sportdata);
      }
    });
  }, []);

  const delayedSearch = useCallback(
    _.debounce(async (val) => {
      if (val !== "") {
        try {
          // setLoader(true)
          await CustomGetAPI("/Venue/GetCitiesByName/" + val).then((result) => {
            if (result === undefined || result === "") {
              alert("Something went wrong");
            } else {
              result = JSON.parse(result);
              setShowsearchList(true);
              setSearchData(result?.cities);
            }
          });
        } catch (error) {
          // console.log(error);
        } finally {
          // setLoader(false)
        }
      } else {
        setShowsearchList(false);
      }
    }, 500),
    []
  );

  const handleChange = (e) => {
    const { value } = e.target;
    delayedSearch(value);
    setSearchText(value);
  };
  const isLoggedIn = window.localStorage.getItem("UserMobileNo");
  const handleLocationClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        fetchCityName(latitude, longitude);
      });
    }
  };

  const fetchCityName = async (latitude, longitude) => {
    const apiKey = process.env.REACT_APP_Google_API_KEY;
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
    );
    const data = await response.json();

    if (data.status === "OK") {
      const city = data.results[0].address_components.find((component) =>
        component.types.includes("locality")
      )?.long_name;
      setSearchText(city || "Location not found");
      navigate(
        `/venue-search/${city.toLocaleLowerCase()}/${
          props.isevent === "true" ? "events" : "sports"
        }/${props.sport ? props.sport : "all"}`
      );
    }
  };

  useEffect(() => {
    if (cityData?.length > 0) {
      const availLetters = cityData
        ?.filter((city) =>
          city?.cityName?.toLowerCase()?.includes(searchText?.toLowerCase())
        )
        ?.filter((city) => !city?.popularity)
        ?.map((city) => city?.cityName[0]?.toUpperCase())
        ?.filter((letter, index, self) => self.indexOf(letter) === index);
      setAvailableLetters(availLetters);
    }
  }, [cityData, searchText]);

  return (
    <>
      <HelmetMetaTag
        titleName="CricBuddy |Search and Book Venues Near You Online"
        canonical={window.location.href}
        ogtitle="CricBuddy | Book Sports Venues in Ahmedabad Online "
        ogtype="website"
        ogurl={window.location.href}
      />
      <div className="row px-2">
        {/* <div className="col-1">
          <img
            src="/images/backArrow.svg"
            onClick={() => {
              if (!sport) {
                navigate("/home");
              } else {
                setSport(false);
                navigate("/home");
              }
            }}
          />
        </div> */}
        {/* <div className="col-12">
          <h2 className="text-center">Select {!sport ? "City" : "Sport"}</h2>
        </div> */}
      </div>

      {/* <div className="Container my-3">
        <div className="row">
          <div className="col-6 position-relative">
            <img
              className="w-100"
              src="/images/ahmedabad.png"
              alt="Ahmedabad"
            />
            <div className="position-absolute bottom-0 w-100 text-center cityName">
              Ahmedabad
            </div>
          </div>
        </div>
        <Card
          className="venueSearchCard"
          style={{
            borderRadius: "16px",
            background: "#FBFBFB",
            border: "none",
            boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
          }}
        >
          <Card.Body className="my-5">
            <div className="row">
              <div className="col-12 centerAlign">
                <img src="/images/venuetop.svg" className="img-fluid" alt="" />
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-12">
                <div className="mx-3 posRel">
                  <input
                    type="search"
                    className="form-control venueSearch"
                    placeholder="Search cities, places..."
                    value={searchText}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    style={{
                      padding: "6px 10px 6px 40px",
                      borderRadius: "35px",
                    }}
                  />
                  <img src="/images/searchicon.svg" className="search-icon" />
                  <img
                    src="/images/Target.svg"
                    alt=""
                    className="target-icon"
                  />
                  {showSearchList && searchData.length > 0 && (
                    <>
                      <div className="results-list" ref={SearchRef}>
                        {searchData.map((result, id) => {
                          return (
                            <div
                              className="search-result"
                              onClick={(e) =>
                                goToVenueList(result?.id, result?.name)
                              }
                              key={result?.id}
                            >
                              {result?.name}
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <h5 className="mb-4 fw-bold">Popular Cities</h5>

              <div className="grid-container text-center"></div>
            </div>
            {cityData?.map((city) => (
              <button
                className="citiesbox border-0 venueButtons"
                onClick={(e) => goToVenueList("1", "Ahmedabad")}
              >
                {city?.cityName}
              </button>
            ))}
          </Card.Body>
        </Card>
        {isLoggedIn ? (
          <Card
            className="my-3"
            style={{
              borderRadius: "16px",
              background: "#FBFBFB",
              border: "none",
              boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
            }}
          >
            <Card.Body>
              <div className="row">
                <div className="col-4 m-auto centerAlign">
                  <img className="" src="/images/helmet.svg" alt="" />
                </div>
              </div>

              <div className="row mt-3 px-4">
                <div className="col-6 col-lg-3 m-auto centerAlign">
                  <img
                    src="/images/favouritevenues.svg"
                    alt=""
                    onClick={handleSavedVenues}
                    className="cursorClass"
                  />
                </div>
                <div className="col-6 col-lg-3 m-auto centerAlign">
                  <img
                    src="/images/savedqueries.svg"
                    alt=""
                    onClick={handleSavedQueries}
                    className="cursorClass"
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        ) : (
          <></>
        )}
      </div> */}
      {!sport ? (
        <>
          <div className="row flex-column flex-md-row mt-md-2 border-bottom mx-0 pb-2">
            <div className="col-md-8 px-0">
              {/* {userLocation && (
                <label
                  className="d-inline-flex align-items-center gap-2 rounded-2 px-3 py-1 text-white Montserrat mb-md-0 mb-3"
                  style={{ backgroundColor: "#A51E22" }}
                >
                  <span className="text-capitalize">{userLocation}</span>
                  <img
                    src="/images/CrossBgWhite.svg"
                    alt="CrossBgWhite"
                    height={20}
                    width={20}
                    className="cursor-pointer"
                    onClick={() => {
                      localStorage.removeItem("userLocation");
                      navigate("/");
                    }}
                  />
                </label>
              )} */}
              <div className="row mx-0 ">
                <p
                  className="px-0 mb-md-2 mb-0"
                  style={{ color: "#545454", fontWeight: "500" }}
                >
                  Popular Cities
                </p>
                {cityData
                  ?.filter((city) => city.popularity)
                  ?.map((city, index) => (
                    <>
                      <div
                        key={index}
                        className="px-0 col-4 col-md-2 cursor-pointer"
                      >
                        <div
                          className={`p-2 d-flex flex-column align-items-center ${
                            window.innerWidth > 768
                              ? index !== 0 && "border-start"
                              : index % 3 !== 0 && "border-start"
                          }`}
                          onClick={(e) => {
                            //setSport(true);
                            setSelectedCity(city?.cityName.toLocaleLowerCase());
                            localStorage.setItem(
                              "userLocation",
                              city?.cityName
                                ?.replaceAll(" ", "-")
                                ?.toLocaleLowerCase()
                            );
                            if (!props?.packagePage) {
                              let filterObject = JSON.parse(
                                localStorage.getItem("filterObjects")
                              );
                              if (filterObject) {
                                filterObject = { ...filterObject };
                                filterObject["area"] = [];
                                localStorage.setItem(
                                  "filterObjects",
                                  JSON.stringify(filterObject)
                                );
                              }
                              window.location.href = `/venue-search/${city?.cityName
                                .replaceAll(" ", "-")
                                .toLocaleLowerCase()}/${
                                props.isevent === "true" ? "events" : "sports"
                              }/${props.sport ? props.sport : "all"}`;
                            } else {
                              window.location.reload();
                            }
                          }}
                        >
                          <div className="d-flex flex-column align-items-center">
                            <img
                              className="img-fluid"
                              src={`/images/${city?.cityName.toLocaleLowerCase()}.webp`}
                              alt={city?.cityName.toLocaleLowerCase()}
                              height={35}
                              width={35}
                            />
                            <div className=" text-center pt-1 pt-md-2 cityText">
                              {userLocation
                                ?.split("-")
                                [
                                  userLocation?.split("-")?.length - 1
                                ]?.toLowerCase() ===
                              city.cityName?.toLowerCase() ? (
                                <b style={{ color: "#a51e22" }}>
                                  {city?.cityName} ({city?.venueCount})
                                </b>
                              ) : (
                                <>
                                  {city?.cityName} ({city?.venueCount})
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {window.innerWidth < 768 && index === 2 && (
                        <hr
                          className="my-2 mx-auto"
                          style={{ opacity: 0.1, width: "98%" }}
                        />
                      )}
                    </>
                  ))}
              </div>
            </div>
            <div className="col-md-3 offset-md-1 px-md-2 px-0 mt-3 mt-md-0">
              <input
                type="text"
                className="form-control venueSearch customize-placeholder"
                placeholder="Search city"
                value={searchText}
                onChange={(e) => {
                  handleChange(e);
                }}
                style={{
                  padding: "6px 10px 6px 40px",
                  borderRadius: "5px",
                }}
              />
              <img src="/images/searchicon.svg" className="search-icon" />
              {/* <div
                className="target-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleLocationClick(e);
                }}
              >
                <b className="location-text">Current location</b> &nbsp;
                <img src="/images/Target.svg" alt="" className="" />
              </div> */}
              {/* {showSearchList && searchData.length > 0 && (
                <>
                  <div className="results-list" ref={SearchRef}>
                    {searchData.map((result, id) => {
                      return (
                        <div
                          className="search-result"
                          onClick={(e) =>
                            goToVenueList(result?.id, result?.name)
                          }
                          key={result?.id}
                        >
                          {result?.name}
                        </div>
                      );
                    })}
                  </div>
                </>
              )} */}
            </div>
          </div>

          {/* <div className="row">
            <p style={{ color: "#545454", fontWeight: "500" }}>
              Popular Cities
            </p>
            {cityData?.map((city) => (
              <>
                {city?.popularity && (
                  <div
                    className="mb-4 mt-3 mt-md-0 col-md-1 col-3 cursor-pointer"
                    onClick={(e) => {
                      //setSport(true);
                      setSelectedCity(city?.cityName.toLocaleLowerCase());
                      localStorage.setItem(
                        "userLocation",
                        city?.cityName
                          ?.replaceAll(" ", "-")
                          ?.toLocaleLowerCase()
                      );
                      if (!props?.packagePage) {
                        window.location.href = `/venue-search/${city?.cityName
                          .replaceAll(" ", "-")
                          .toLocaleLowerCase()}/${
                          props.isevent === "true" ? "events" : "sports"
                        }/${props.sport ? props.sport : "all"}`;
                      } else {
                        window.location.reload();
                      }
                    }}
                  >
                    <img
                      className="img-fluid"
                      src={`/images/${city?.cityName.toLocaleLowerCase()}.webp`}
                      alt={city?.cityName.toLocaleLowerCase()}
                    />
                    <div className=" text-center py-1 py-md-2 cityText">
                      {userLocation
                        ?.split("-")
                        [
                          userLocation?.split("-")?.length - 1
                        ]?.toLowerCase() === city.cityName?.toLowerCase() ? (
                        <b style={{ color: "#a51e22" }}>{city?.cityName}</b>
                      ) : (
                        city?.cityName
                      )}
                    </div>
                  </div>
                )}
              </>
            ))}
          </div> */}
          <div className="row mt-2 mx-0">
            <div className="d-none d-md-flex flex-wrap my-2 px-0">
              {[...Array(26)].map((_, i) => {
                const alphabet = String.fromCharCode(65 + i);
                const isPresent = availableLetters.includes(alphabet);

                return (
                  <div
                    onClick={() => {
                      if (isPresent) handleHorizontalScroll(alphabet);
                    }}
                    onMouseEnter={() => setHoveredAlphabet(alphabet)}
                    onMouseLeave={() => setHoveredAlphabet("")}
                    style={{ pointerEvents: isPresent ? "auto" : "none" }}
                    className="pe-1"
                  >
                    <label
                      key={alphabet}
                      className="px-2 me-2 Montserrat cursor-pointer fw-medium"
                      style={{
                        backgroundColor:
                          selectedLetter?.toLowerCase() ===
                          alphabet?.toLowerCase()
                            ? "#A51E22"
                            : "transparent",
                        color:
                          selectedLetter?.toLowerCase() ===
                          alphabet?.toLowerCase()
                            ? "#FFFFFF"
                            : "#A6A6A6",
                        opacity: isPresent ? 1 : 0.3,
                        border: "0.6px solid #0202021A",
                        borderRadius: "5px",
                      }}
                    >
                      {alphabet}
                    </label>
                  </div>
                );
              })}
            </div>
            {/* <p style={{ color: "#545454", fontWeight: "500" }}>More Cities</p> */}
            {cityData &&
              (() => {
                const grouped = cityData
                  .filter((city) =>
                    city?.cityName
                      ?.toLowerCase()
                      ?.includes(searchText?.toLowerCase())
                  )
                  .filter((city) => !city?.popularity)
                  .sort((a, b) => a.cityName.localeCompare(b.cityName))
                  .reduce((acc, city) => {
                    const letter = city.cityName[0].toUpperCase();
                    if (!acc[letter]) acc[letter] = [];
                    acc[letter].push(city);
                    return acc;
                  }, {});

                const MAX_ROWS_PER_COLUMN = 7;
                const columns = [];
                let currentColumn = [];
                let remainingRows = MAX_ROWS_PER_COLUMN;

                Object.entries(grouped).forEach(([letter, cities]) => {
                  let cityIndex = 0;
                  let isFirstChunk = true;

                  while (cityIndex < cities.length || isFirstChunk) {
                    if (remainingRows === 0) {
                      columns.push(currentColumn);
                      currentColumn = [];
                      remainingRows = MAX_ROWS_PER_COLUMN;
                    }

                    let spaceForCities = isFirstChunk
                      ? remainingRows - 1
                      : remainingRows;

                    if (remainingRows >= 1) {
                      const chunk = {
                        letter: isFirstChunk ? letter : null,
                        groupLetter: letter,
                        cities: cities.slice(
                          cityIndex,
                          cityIndex + spaceForCities
                        ),
                      };

                      currentColumn.push(chunk);
                      cityIndex += spaceForCities;
                      remainingRows -=
                        chunk.cities.length + (isFirstChunk ? 1 : 0);
                      isFirstChunk = false;
                    } else {
                      columns.push(currentColumn);
                      currentColumn = [];
                      remainingRows = MAX_ROWS_PER_COLUMN;
                    }
                  }
                });

                if (currentColumn.length > 0) {
                  columns.push(currentColumn);
                }

                return (
                  <div className="mt-2 px-0" style={{ overflowX: "auto" }}>
                    <div
                      className="d-flex flex-md-row flex-column flex-md-nowrap mx-0"
                      style={{ minWidth: "100%" }}
                    >
                      {columns.map((column, colIndex) => (
                        <div
                          className="me-2"
                          style={{ minWidth: "190px" }}
                          key={colIndex}
                        >
                          {column.map(
                            ({ letter, groupLetter, cities }, sectionIndex) => (
                              <div
                                key={`${letter || colIndex}-${sectionIndex}`}
                                id={letter || undefined}
                              >
                                {letter && (
                                  <label
                                    className={`fw-bold py-2 mb-0 Montserrat fs-5 ${
                                      !hoveredAlphabet
                                        ? "opacity-100"
                                        : hoveredAlphabet?.toLowerCase() ===
                                          letter?.toLowerCase()
                                        ? "opacity-100"
                                        : "opacity-25"
                                    }`}
                                    style={{ lineHeight: "24px" }}
                                  >
                                    {letter}
                                  </label>
                                )}
                                {cities.map((city) => (
                                  <div
                                    key={city.cityId}
                                    className={`cursor-pointer ${
                                      !hoveredAlphabet
                                        ? "opacity-100"
                                        : hoveredAlphabet?.toLowerCase() ===
                                          groupLetter?.toLowerCase()
                                        ? "opacity-100"
                                        : "opacity-25"
                                    }`}
                                    onClick={() => {
                                      setSelectedCity(
                                        city.cityName.toLowerCase()
                                      );
                                      localStorage.setItem(
                                        "userLocation",
                                        city.cityName
                                          .replace(/\s+/g, "-")
                                          .toLowerCase()
                                      );
                                      if (!props?.packagePage) {
                                        let filterObject = JSON.parse(
                                          localStorage.getItem("filterObjects")
                                        );
                                        if (filterObject) {
                                          filterObject = { ...filterObject };
                                          filterObject["area"] = [];
                                          localStorage.setItem(
                                            "filterObjects",
                                            JSON.stringify(filterObject)
                                          );
                                        }
                                        window.location.href = `/venue-search/${city.cityName
                                          .replace(/\s+/g, "-")
                                          .toLowerCase()}/${
                                          props.isevent === "true"
                                            ? "events"
                                            : "sports"
                                        }/${props.sport || "all"}`;
                                      } else {
                                        window.location.reload();
                                      }
                                    }}
                                  >
                                    <div
                                      className={`py-2 fw-600 Montserrat d-flex justify-content-between justify-content-md-start gap-2 `}
                                      style={{
                                        background:
                                          userLocation
                                            ?.split("-")
                                            ?.at(-1)
                                            ?.toLowerCase() ===
                                          city.cityName.toLowerCase()
                                            ? ""
                                            : "",
                                        color:
                                          userLocation
                                            ?.split("-")
                                            ?.at(-1)
                                            ?.toLowerCase() ===
                                          city.cityName.toLowerCase()
                                            ? "#a51e22"
                                            : "#8A8A8A",
                                        borderRadius: "10px",
                                        lineHeight: "24px",
                                      }}
                                    >
                                      {city.cityName}
                                      <span className="d-none d-md-block fw-light">
                                        {" "}
                                        ({city.venueCount})
                                      </span>
                                      <span className="d-block d-md-none">
                                        {" "}
                                        {city.venueCount}
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}
          </div>
        </>
      ) : (
        <div className="row">
          {sportData?.map((sport) => (
            <div
              className="col-4 col-md-2 mt-4"
              onClick={(e) => {
                navigate(
                  `/venue-search/${selectedCity}/${
                    props.isevent === "true" ? "events" : "sports"
                  }/${sport?.sportname.toLocaleLowerCase()}`
                );
              }}
            >
              <img
                className="w-100"
                src={`/images/${sport?.sportname.toLocaleLowerCase()}.png`}
                alt={sport?.sportname.toLocaleLowerCase()}
              />
              <div className=" w-100 text-center py-1 py-md-2 ">
                {sport?.sportname}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
